import { getIndexedDb } from '@/utils/indexedDb/getIndexedDb'

export const deleteAllIndexedDbDatabases = async () => {
    const indexedDbs = await indexedDB.databases()

    // Closes all databases otherwise delete will fall in onBlocked
    indexedDbs.map(async (db) => {
        if (db.name && db.version) {
            const database = await getIndexedDb(db.name, db.version)
            database.close()
        }
    })

    const deletePromises = indexedDbs.map(async (db) => {
        return new Promise<void>((resolve, reject) => {
            const request = indexedDB.deleteDatabase(db.name as string)

            request.onblocked = () => {
                console.error(`Database ${db.name} is blocked and cannot be deleted.`)
                resolve()
            }

            request.onsuccess = () => {
                console.log(`Database ${db.name} deleted successfully.`)
                resolve()
            }

            request.onerror = async () => {
                reject(`Failed to delete database "${db.name}", error: ${request.error?.message}`)
            }
        })
    })

    await Promise.all(deletePromises)
}
